import { render, staticRenderFns } from "./treatment-option-selector-button.vue?vue&type=template&id=fc275028&"
import script from "./treatment-option-selector-button.vue?vue&type=script&lang=js&"
export * from "./treatment-option-selector-button.vue?vue&type=script&lang=js&"
import style0 from "./treatment-option-selector-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports